import { useFlags } from 'launchdarkly-react-client-sdk';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { ActivityTab } from './ActivityTab';
import { OverviewTab } from './OverviewTab';
import {
  type PlaybookPageProps,
  PlaybookPageProvider,
} from './PlaybookPageContext';
import { PlaybookPageSidebar } from './PlaybookPageSidebar';
import { PresentationsProvider } from './PresentationsContext';
import { PresentationsTab } from './PresentationsTab';
import type { PlaybookPageTab } from './types';

const pageByTabId: (
  activityFlag?: boolean
) => Record<PlaybookPageTab, ReactNode> = (activityFlag) => ({
  overview: <OverviewTab />,
  presentations: <PresentationsTab />,
  activity: activityFlag ? <ActivityTab /> : null,
});

export const PlaybookPage = (props: PlaybookPageProps) => {
  const { tabId } = useParams<{ tabId: PlaybookPageTab }>();
  const flags = useFlags();
  const tab = pageByTabId(flags.playbookActivityTab)[tabId];

  return (
    <PlaybookPageProvider {...props}>
      <PresentationsProvider>
        <div className="flex h-full w-full">
          <PlaybookPageSidebar />
          {tab}
        </div>
      </PresentationsProvider>
    </PlaybookPageProvider>
  );
};
